import {Setting} from "./Setting";

export const epochSetting: Setting = {
    key: "Epoch",
    title: "Эпоха",
    description: `Эпоха — это период времени, характеризующийся определенными событиями, социальными, политическими и технологическими условиями, которые влияют на развитие мира игры и жизни персонажей. Эпохи могут включать в себя долгосрочные изменения, такие как падение империй, освоение новых технологий, появление магических рас, революции или другие значительные события, которые формируют мировоззрение персонажей, их поведение и отношения между различными группами.`,
    components: [
        {
            title: "Древние эпохи",
            subComponents: [
                {
                    title: "Эпоха мифов и легенд",
                    description: `Время, когда мир только начинал свою историю, и различные мифы, легенды и божества были центральной частью культуры. Эпохи, когда магия была на пике, а чудовища и герои заполняли мир.`,
                    examples: ["Эпоха создания мира, когда боги и демоны активно вмешивались в дела людей"]
                },
                {
                    title: "Эпоха великих империй",
                    description: `Период, когда крупные империи и цивилизации правили огромными территориями. Этот период может характеризоваться войнами, построением монументальных сооружений и поисками знаний.`,
                    examples: ["Эпоха строительства пирамид и храмов, правление великих монархов и завоевателей"]
                }
            ]
        },
        {
            title: "Средние века",
            subComponents: [
                {
                    title: "Эпоха рыцарей и магии",
                    description: `Время рыцарей, дворянства, феодальных систем и великих магических практик. Рыцарские ордена, чародеи, монастыри, и храмовые заказы играют важную роль.`,
                    examples: ["Эпоха крестовых походов, когда магия и религия были неотъемлемой частью общественной жизни"]
                },
                {
                    title: "Эпоха гильдий и торговцев",
                    description: `Период, когда важную роль в обществе играют торговые гильдии, мастеровые, купцы и рост городов. В этом времени усиливается капитализм и развитие технологий.`,
                    examples: ["Время становления великих торговых путей и открытие новых морских маршрутов"]
                }
            ]
        },
        {
            title: "Ренессанс и эпоха открытий",
            subComponents: [
                {
                    title: "Эпоха научных открытий",
                    description: `Время, когда начинается развитие науки и философии. Ученые, маги и алхимики исследуют мир, и появляются новые технологии и теории, меняющие представление о реальности.`,
                    examples: ["Открытия в астрономии, алхимии, а также зарождение новых философских школ"]
                },
                {
                    title: "Эпоха великих путешествий",
                    description: `Период, когда исследователи открывают новые земли и культуры. Начинается освоение новых континентов и появляются карты и путеводители.`,
                    examples: ["Эпоха великих мореплавателей, колонизация Нового Света"]
                }
            ]
        },
        {
            title: "Модерн и индустриальная эпоха",
            subComponents: [
                {
                    title: "Эпоха индустриализации",
                    description: `Время, когда происходит массовая промышленная революция, создание фабрик, развитие транспорта и новых производственных технологий.`,
                    examples: ["Появление паровых машин, железных дорог, развитие города как промышленного центра"]
                },
                {
                    title: "Эпоха социальных революций",
                    description: `Время социальных и политических изменений, революций, борьбы за права человека и появление новых политических систем.`,
                    examples: ["Революции, борьба за права женщин, рабочие движения"]
                }
            ]
        },
        {
            title: "Современность и будущее",
            subComponents: [
                {
                    title: "Эпоха технологий и глобализации",
                    description: `Период, когда технологии и интернет влияют на повседневную жизнь, происходят глобальные изменения в экономике, политике и культуре. Новые научные достижения открывают горизонты для будущего.`,
                    examples: ["Развитие интернета, биотехнологий, искусственного интеллекта"]
                },
                {
                    title: "Эпоха пост-апокалипсиса",
                    description: `Время, наступившее после глобальной катастрофы, когда мир сильно изменился. Природные катастрофы, войны или технологические сбои привели к разрушению привычного мира.`,
                    examples: ["Мир после ядерной войны, экологической катастрофы или падения цивилизации"]
                }]
        },
        {
            title: "Магическая или фантастическая эпоха",
            subComponents: [
                {
                    title: "Эпоха великой магии",
                    description: `Время, когда магия достигла своего расцвета. Колдуны и маги правят миром, а магические существа и артефакты играют важную роль в повседневной жизни.`,
                    examples: ["Эпоха великих магистров, когда магия обучалась в академиях и использовалась для создания чудесных технологий"]
                },
                {
                    title: "Эпоха магической войны",
                    description: `Период, когда магические силы вступают в конфликт, разрушая миры и создавая разрушения. Могут быть войны между магическими государствами, орденами или магическими расами.`,
                    examples: ["Война магов, разрушившая королевства, или магические существа, осаждающие человечество"]
                }
            ]
        },
        {
            title: "Далекое будущее",
            subComponents: [
                {
                    title: "Эпоха космических путешествий",
                    description: `Время, когда человечество колонизировало другие планеты, освоило другие галактики и взаимодействует с инопланетными расами.`,
                    examples: ["Путешествия через космос, межгалактические войны, колонии на Марсе"]
                },
                {
                    title: "Эпоха искусственного интеллекта и сингулярности",
                    description: `Период, когда искусственный интеллект становится неотъемлемой частью общества, и начинается новая эра человечества с возможностью слияния с машинами.`,
                    examples: ["Слияние человека и машины, создание сверхразумных искусственных существ"]
                }]
        }
    ],

    prompt: {
        component: {
            list: "Сгенерируй эпоху в которую происходит история. Сгенерируй только один компонент с описанием эпохи истории.",
            single: "Сгенерируй эпоху в которую происходит история. Сгенерируй только один компонент с описанием эпохи истории.",
            extend: "Дополни эпоху истории подробностями и разбей на абзацы."
        }, element: {
            list: "Сгенерируй эпоху в которую происходит история. Сгенерируй элементы с описанием эпохи истории.",
            single: "Сгенерируй эпоху в которую происходит история. Сгенерируй только один элемент с описанием эпохи истории.",
            extend: "Дополни элемент эпохи истории подробностями и разбей на абзацы."
        }, lore: {
            list: "Создай элементы лора на основе этой эпохи. Ее историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этой эпохи. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора эпохи и разбей на абзацы."
        }

    }
}